import React from "react";
import { Avatar, Layout, message, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import Logo from "../../assets/logo/Logo.png";
import { Form, Input } from "antd";
import BpsButton from "../../ui/Button/Button";
/* import Instagram from "../../assets/media-icons/Instagram.png";
import LinkedIn from "../../assets/media-icons/Linkedin.png";
import Twitter from "../../assets/media-icons/Twitter.png"; */
import { useDispatch, useSelector } from "react-redux";
import { login } from './../../redux/actions/auth';
import { selectAuthLoading } from "../../redux/selectors/authSelectors";
import { redirectAfterDelay } from "../../utils/utils";
import { isAdmin, isVendor } from "../../helpers/config";


function Signin() {
  const { Footer, Content } = Layout;
  const dispatch = useDispatch();
  const isLoading = useSelector(selectAuthLoading);

  const onLoginRequest = (values) => {
    
    dispatch(login(values)).then((response) => {
      message.success(response?.message);
      
      if (isAdmin) {
        redirectAfterDelay('/dashboard');
      }
      else if (isVendor) {
        redirectAfterDelay('/dashboard/event-vendors');
      }
      
    }).catch(error => console.log(error));
  }

  return (
    <Layout className="bps-signin__container">
      <Space direction="vertical" size={245}>
        <Content className="bps-signin__inner">
          <div style={{marginBottom: -20}}>
            <img src={Logo} style={{maxWidth: 120}} />
          </div>
          <p>Authorize access</p>
          <Form name="basic" layout="vertical" autoComplete="off" onFinish={onLoginRequest}>
            <Form.Item
              label={<label>Email address</label>}
              name="username"
              rules={[
                { required: true, message: "Please enter your email" },
                {
                  type: "email",
                  message: "Please enter a valid email",
                },
              ]}
              hasFeedback
            >
              <Input
                className="bps-signin__input"
                placeholder="Email address"
              />
            </Form.Item>

            <Form.Item
              label={<label>Password</label>}
              name="password"
              className="bps-signin__inputWrapper"
              rules={[{ required: true }]}
              hasFeedback
            >
              <Input.Password
                className="bps-signin__password"
                placeholder="********"
              />
            </Form.Item>
            <Form.Item>
              <BpsButton
                label={"Access account"}
                customClass="bps-signin__button"
                shape="round"
                buttonType="primary"
                htmlType='submit'
                loading={isLoading}
              //onClick={() => navigate("/dashboard")}
              />
            </Form.Item>
          </Form>
        </Content>
        {/* <Footer className="bps-signin__footer">
          <div>
            <span className="bps-signin__footerLinks">
              <Typography.Link>About Us</Typography.Link>
              <Typography.Link>Help Center</Typography.Link>
              <Typography.Link>Privacy</Typography.Link>
              <Typography.Link>Terms of Use</Typography.Link>
            </span>
            <span className="bps-signin__footerIcons">
              <img src={Instagram} alt="/" />
              <img src={LinkedIn} alt="/" />
              <img src={Twitter} alt="/" />
            </span>
          </div>
        </Footer> */}
      </Space>
    </Layout>
  );
}

export default Signin;
